import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { IndexName, WidgetConfig } from '../types'

const initialState: Omit<WidgetConfig, 'locationTypes'> & {
  ready: boolean
  mapsError: Error | null
} = {
  appId: '',
  apiKey: '',
  indexName: 'locations' as IndexName,
  postsPerPage: 10,
  mapsApiKey: '',
  geoLocation: {
    lat: 0,
    lng: 0
  },
  ready: false,
  imgixSrcUrl: '',
  imgixTargetUrl: '',
  redirectBaseUrl: '',
  mapsError: null,
  contactUrl: '',
  microchurchSlug: '',
  placeholderImageUrl: '',
  placeholderLocationBlackUrl: '',
  placeholderLocationWhiteUrl: '',
  privacyPageUrl: ''
}

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(
      _state,
      action: PayloadAction<Omit<typeof initialState, 'ready' | 'mapsError'>>
    ) {
      return {
        ...action.payload,
        ready: true,
        mapsError: null
      }
    },
    setGeoLocation(state, action: PayloadAction<{ lat: number; lng: number }>) {
      state.geoLocation = action.payload
    },
    setMapsError(state, action: PayloadAction<Error>) {
      state.mapsError = action.payload
    }
  }
})

export const configActions = configSlice.actions
